/**
 * Matcha Bundle Builder
 * Multi-step product bundle wizard with direct checkout link via /cart/variantId:qty
 */
(function() {
  'use strict';

  const builder = document.getElementById('mbb');
  if (!builder) return;

  // Load product metadata from JSON script tag
  let productMeta = {};
  try {
    const dataEl = document.getElementById('mbb-product-data');
    if (dataEl) productMeta = JSON.parse(dataEl.textContent);
  } catch(e) {
    console.error('MBB: Failed to parse product data', e);
  }

  const SUMMARY_STEP = 5;
  let currentStep = 1;

  // State: { variantId: { ...meta, qty: number } }
  let bundleState = {};

  // DOM cache
  const steps = builder.querySelectorAll('.mbb__step');
  const progressDots = builder.querySelectorAll('.mbb__progress-dot');
  const modalOverlay = builder.querySelector('.mbb__modal-overlay');

  /* =====================
   * Navigation
   * ===================== */
  function goToStep(step) {
    if (step < 1 || step > SUMMARY_STEP) return;
    currentStep = step;

    steps.forEach(function(s) { s.classList.remove('active'); });
    var target = builder.querySelector('[data-step="' + step + '"]');
    if (target) target.classList.add('active');

    progressDots.forEach(function(dot, i) {
      dot.classList.toggle('active', i < step);
    });

    if (step === SUMMARY_STEP) renderSummary();
    updateStepButtons();
    builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hasCategory(category) {
    return Object.values(bundleState).some(function(item) {
      return item.category === category && item.qty > 0;
    });
  }

  var chevronRight = ' <svg style="display:inline-block;vertical-align:-2px;margin-left:4px" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  function appendChevron(btn, text) {
    btn.innerHTML = text + chevronRight;
  }

  function updateOfferProgress() {
    var progressEl = builder.querySelector('[data-mbb-offer-progress]');
    if (!progressEl) return;
    var fillEl = progressEl.querySelector('[data-mbb-offer-fill]');
    var labels = progressEl.querySelectorAll('.mbb__offer-labels span');
    if (!fillEl) return;

    var matchaCount = 0;
    Object.values(bundleState).forEach(function(item) {
      if (item.category === 'matcha') matchaCount += item.qty;
    });

    var steps = 4;
    var progress = Math.min(matchaCount / steps, 1);
    fillEl.style.width = (progress * 100) + '%';

    labels.forEach(function(label, i) {
      label.classList.toggle('mbb__offer-label--done', matchaCount > i);
      label.classList.toggle('mbb__offer-label--active', matchaCount === i);
    });

    if (matchaCount >= steps) {
      if (!progressEl.classList.contains('mbb__offer--complete')) {
        progressEl.classList.add('mbb__offer--complete');
        fillEl.style.background = 'var(--mbb-green)';
      }
    } else {
      progressEl.classList.remove('mbb__offer--complete');
    }
  }

  function updateStepButtons() {
    var step1Btn = builder.querySelector('[data-step="1"] .mbb__btn--primary[data-requires="matcha"]');
    if (step1Btn) {
      var has = hasCategory('matcha');
      step1Btn.disabled = !has;
      appendChevron(step1Btn, has ? 'Weiter' : 'Wähle mindestens 1 Matcha');
    }

    builder.querySelectorAll('.mbb__btn--primary[data-requires]').forEach(function(btn) {
      if (btn === step1Btn) return;
      var required = btn.dataset.requires;
      var empty = btn.dataset.textEmpty;
      var filled = btn.dataset.textFilled;
      var selected = hasCategory(required);
      if (empty && filled) {
        appendChevron(btn, selected ? filled : empty);
        btn.classList.toggle('mbb__btn--muted', !selected);
      }
    });

    builder.querySelectorAll('.mbb__btn--primary[data-goto]:not([data-requires])').forEach(function(btn) {
      if (btn.classList.contains('mbb__checkout-btn')) return;
      if (!btn.querySelector('svg')) appendChevron(btn, btn.textContent.trim());
    });
  }

  // Bind navigation buttons
  builder.querySelectorAll('[data-goto]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      goToStep(parseInt(btn.dataset.goto));
    });
  });

  /* =====================
   * Quantity Controls
   * ===================== */
  builder.querySelectorAll('[data-qty-control]').forEach(function(container) {
    var variantId = container.dataset.variantId;
    var meta = productMeta[variantId];
    if (!meta) return;

    var minusBtn = container.querySelector('.mbb__qty-minus');
    var plusBtn = container.querySelector('.mbb__qty-plus');
    var valEl = container.querySelector('.mbb__qty-val');

    function updateDisplay() {
      var qty = (bundleState[variantId] && bundleState[variantId].qty) || 0;
      valEl.textContent = qty;
      minusBtn.disabled = qty <= 0;
    }

    minusBtn.addEventListener('click', function() {
      if (bundleState[variantId] && bundleState[variantId].qty > 0) {
        bundleState[variantId].qty--;
        if (bundleState[variantId].qty === 0) delete bundleState[variantId];
      }
      updateDisplay();
      updateStepButtons();
      updateOfferProgress();
    });

    plusBtn.addEventListener('click', function() {
      if (!bundleState[variantId]) {
        bundleState[variantId] = Object.assign({}, meta, { qty: 0 });
      }
      bundleState[variantId].qty++;
      updateDisplay();
      updateStepButtons();
      updateOfferProgress();
    });

    updateDisplay();
  });

  /* =====================
   * Checkbox Controls (Accessories)
   * ===================== */
  builder.querySelectorAll('[data-checkbox]').forEach(function(el) {
    var variantId = el.dataset.variantId;
    var meta = productMeta[variantId];
    if (!meta) return;

    var isDefaultChecked = el.dataset.defaultChecked === 'true';

    // Set default state
    if (isDefaultChecked) {
      bundleState[variantId] = Object.assign({}, meta, { qty: 1 });
      el.classList.add('checked');
    }

    if (!isDefaultChecked) {
      el.addEventListener('click', function() {
        if (bundleState[variantId]) {
          delete bundleState[variantId];
          el.classList.remove('checked');
        } else {
          bundleState[variantId] = Object.assign({}, meta, { qty: 1 });
          el.classList.add('checked');
        }
      });
    }
  });

  /* =====================
   * Glass card click-to-select
   * ===================== */
  builder.querySelectorAll('.mbb__glass-img-wrap').forEach(function(wrap) {
    wrap.addEventListener('click', function() {
      var targetVariant = wrap.dataset.variantTarget;
      var card = wrap.closest('.mbb__glass-card');
      var qtyControl = card.querySelector('[data-qty-control]');
      var variantId = qtyControl.dataset.variantId;
      var meta = productMeta[variantId];
      if (!meta) return;

      if (!bundleState[variantId]) {
        bundleState[variantId] = Object.assign({}, meta, { qty: 1 });
        var valEl = qtyControl.querySelector('.mbb__qty-val');
        if (valEl) valEl.textContent = '1';
        var minusBtn = qtyControl.querySelector('.mbb__qty-minus');
        if (minusBtn) minusBtn.disabled = false;
      }
    });
  });

  /* =====================
   * Product Info Modal
   * ===================== */
  builder.querySelectorAll('[data-open-modal]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var modalId = btn.dataset.openModal;
      var contentTpl = builder.querySelector('[data-modal-content="' + modalId + '"]');
      if (contentTpl && modalOverlay) {
        modalOverlay.querySelector('.mbb__modal-body').innerHTML = contentTpl.innerHTML;
        var titleEl = modalOverlay.querySelector('.mbb__modal-title');
        if (titleEl) titleEl.textContent = btn.dataset.modalTitle || '';
        modalOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Video link → opens embedded video in the same modal
  builder.querySelectorAll('.mbb__video-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var url = link.dataset.videoUrl || '';
      if (!url || !modalOverlay) return;
      var embedUrl = url.replace('watch?v=', 'embed/').replace('youtu.be/', 'youtube.com/embed/');
      modalOverlay.querySelector('.mbb__modal-body').innerHTML =
        '<div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:8px">' +
          '<iframe src="' + escapeHtml(embedUrl) + '?autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0" allow="autoplay;encrypted-media" allowfullscreen></iframe>' +
        '</div>';
      var titleEl = modalOverlay.querySelector('.mbb__modal-title');
      if (titleEl) titleEl.textContent = 'Video';
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeModal() {
    if (modalOverlay) {
      modalOverlay.classList.remove('open');
      document.body.style.overflow = '';
      var iframe = modalOverlay.querySelector('iframe');
      if (iframe) iframe.src = '';
    }
  }

  if (modalOverlay) {
    var closeBtn = modalOverlay.querySelector('.mbb__modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) closeModal();
    });
  }

  /* =====================
   * Summary & Checkout
   * ===================== */
  function syncStepControls(variantId) {
    // Reflect qty change back to the step controls (e.g. user removes on summary)
    var qty = bundleState[variantId] ? bundleState[variantId].qty : 0;
    var qtyControl = builder.querySelector('[data-qty-control][data-variant-id="' + variantId + '"]');
    if (qtyControl) {
      var valEl = qtyControl.querySelector('.mbb__qty-val');
      if (valEl) valEl.textContent = qty;
      var minusBtn = qtyControl.querySelector('.mbb__qty-minus');
      if (minusBtn) minusBtn.disabled = qty <= 0;
    }
    var checkbox = builder.querySelector('[data-checkbox][data-variant-id="' + variantId + '"]');
    if (checkbox) checkbox.classList.toggle('checked', qty > 0);
  }

  function renderSummary() {
    var container = builder.querySelector('.mbb__summary-items');
    var totalEl = builder.querySelector('.mbb__summary-total-price');
    var checkoutBtn = builder.querySelector('.mbb__checkout-btn');
    if (!container) return;

    container.innerHTML = '';
    var total = 0;
    var items = [];

    Object.keys(bundleState).forEach(function(variantId) {
      var item = bundleState[variantId];
      if (item.qty > 0) items.push([variantId, item]);
    });
    items.sort(function(a, b) { return (a[1].free ? 1 : 0) - (b[1].free ? 1 : 0); });

    var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>';

    if (items.length === 0) {
      container.innerHTML = '<div class="mbb__summary-empty">Dein Bundle ist leer. Geh zurück und wähle Produkte aus.</div>';
      if (checkoutBtn) {
        checkoutBtn.classList.add('disabled');
        checkoutBtn.removeAttribute('href');
      }
      if (totalEl) totalEl.textContent = '€ 0';
      return;
    }

    items.forEach(function(entry) {
      var variantId = entry[0];
      var item = entry[1];
      var lineTotal = item.free ? 0 : (item.price * item.qty);
      total += lineTotal;

      var subtitleHtml = item.free
        ? '<div class="mbb__summary-unit">*wird kostenlos beigelegt</div>'
        : '<div class="mbb__summary-unit">' + formatPrice(item.price) + ' / Stück</div>';

      var qtyHtml = item.free
        ? ''
        : '<div class="mbb__qty" data-summary-qty data-variant-id="' + variantId + '">' +
            '<button class="mbb__qty-btn mbb__qty-minus" aria-label="Weniger"><svg viewBox="0 0 24 24" width="16" height="16"><use href="#ff3bc845"></use></svg></button>' +
            '<span class="mbb__qty-val">' + item.qty + '</span>' +
            '<button class="mbb__qty-btn mbb__qty-plus" aria-label="Mehr"><svg viewBox="0 0 24 24" width="16" height="16"><use href="#bbdd3b2a"></use></svg></button>' +
          '</div>';

      var removeHtml = item.free
        ? '<span class="mbb__summary-free-tag">GRATIS</span>'
        : '<button class="mbb__summary-remove" data-remove="' + variantId + '" aria-label="Entfernen">' + trashSvg + '</button>';

      var div = document.createElement('div');
      div.className = 'mbb__summary-item';
      div.innerHTML =
        '<img class="mbb__summary-img" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' +
        '<div class="mbb__summary-info">' +
          '<p class="mbb__summary-name">' + escapeHtml(item.title) + '</p>' +
          subtitleHtml +
        '</div>' +
        removeHtml +
        '<div class="mbb__summary-actions">' + qtyHtml + '</div>' +
        '<div class="mbb__summary-price">' + (item.free ? '' : formatPrice(lineTotal)) + '</div>';
      container.appendChild(div);
    });

    // Wire summary qty controls
    container.querySelectorAll('[data-summary-qty]').forEach(function(ctrl) {
      var vid = ctrl.dataset.variantId;
      ctrl.querySelector('.mbb__qty-minus').addEventListener('click', function() {
        if (!bundleState[vid]) return;
        bundleState[vid].qty--;
        if (bundleState[vid].qty <= 0) delete bundleState[vid];
        syncStepControls(vid);
        renderSummary();
      });
      ctrl.querySelector('.mbb__qty-plus').addEventListener('click', function() {
        if (!bundleState[vid]) return;
        bundleState[vid].qty++;
        syncStepControls(vid);
        renderSummary();
      });
    });

    // Wire remove buttons
    container.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = btn.dataset.remove;
        delete bundleState[vid];
        syncStepControls(vid);
        renderSummary();
      });
    });

    if (totalEl) totalEl.textContent = formatPrice(total);

    // Build /cart/variantId:qty,variantId:qty checkout URL — exclude free items
    if (checkoutBtn) {
      var paidItems = items.filter(function(entry) { return !entry[1].free; });
      if (paidItems.length > 0) {
        var cartParts = paidItems.map(function(entry) {
          return entry[0] + ':' + entry[1].qty;
        });
        checkoutBtn.href = '/cart/' + cartParts.join(',');
        checkoutBtn.classList.remove('disabled');
      } else {
        checkoutBtn.classList.add('disabled');
        checkoutBtn.removeAttribute('href');
      }
    }
  }

  function formatPrice(cents) {
    var euros = Math.floor(cents / 100);
    var c = cents % 100;
    if (c === 0) return '€ ' + euros;
    return '€ ' + euros + ',' + (c < 10 ? '0' + c : c);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  // Initialize
  updateStepButtons();
})();

// Progress bar js
document.addEventListener('DOMContentLoaded', function () {
  const offerProgress = document.querySelector('[data-mbb-offer-progress]');
  const offerFill = document.querySelector('[data-mbb-offer-fill]');

  if (!offerProgress || !offerFill) return;

  function updateOfferProgress() {
    let totalMatchaQty = 0;

    document.querySelectorAll('.mbb__step[data-step="1"] [data-qty-control]').forEach(function (qtyControl) {
      const qtyValue = qtyControl.querySelector('.mbb__qty-val');
      totalMatchaQty += parseInt(qtyValue?.textContent || '0', 10);
    });

    const progressPercent = Math.min((totalMatchaQty / 4) * 100, 100);
    offerFill.style.width = progressPercent + '%';
  }

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.mbb__qty-plus') ||
      event.target.closest('.mbb__qty-minus')
    ) {
      setTimeout(updateOfferProgress, 50);
    }
  });

  updateOfferProgress();
});